import React from "react";
import styles from "./ModelSettingsButton.module.css";
import { ProviderIcon, ChevronDownIcon } from "../ModelSettingsPopup/modelIcons";
import type { ModelProvider } from "../ModelSettingsPopup/ModelSettingsPopup";

interface ModelSettingsButtonProps {
  onClick: () => void;
  isOpen: boolean;
  modelDisplayName: string;
  modelProvider: ModelProvider;
}
 
const ModelSettingsButton = React.forwardRef<
  HTMLButtonElement,
  ModelSettingsButtonProps
>(({ onClick, isOpen, modelDisplayName, modelProvider }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    className={`${styles.trigger} ${isOpen ? styles.triggerOpen : ""}`}
    aria-label="Model Settings"
    aria-expanded={isOpen}
  >
    <span className={styles.providerIcon}>
      <ProviderIcon provider={modelProvider} size={10} />
    </span>
    <span className={styles.modelName}>{modelDisplayName}</span>
    <span className={`${styles.chevron} ${isOpen ? styles.chevronFlipped : ""}`}>
      <ChevronDownIcon />
    </span>
  </button>
));
 
ModelSettingsButton.displayName = "ModelSettingsButton";
 
export default ModelSettingsButton;